// extracted by mini-css-extract-plugin
export var active = "faq-page-module--active--22eea";
export var background = "faq-page-module--background--494d7";
export var button = "faq-page-module--button--4876c";
export var categories = "faq-page-module--categories--1a349";
export var category = "faq-page-module--category--2199c";
export var contentform = "faq-page-module--contentform--f37f2";
export var form = "faq-page-module--form--efc56";
export var header = "faq-page-module--header--f2c7d";
export var hero = "faq-page-module--hero--7ba14";
export var hidden = "faq-page-module--hidden--fd6f0";
export var list = "faq-page-module--list--8b9d9";
export var selected = "faq-page-module--selected--10c2f";